import { AnimatePresence, motion } from "framer-motion";
import { QRCodeCanvas } from "qrcode.react";
import { Download, Printer, X } from "lucide-react";
import { MC_MARK_URL } from "@/lib/contact";

const EASE = [0.22, 1, 0.36, 1];

export const QrModal = ({ open, onClose }) => {
    const downloadPng = () => {
        const canvas = document.getElementById("qr-canvas-full");
        if (!canvas) return;
        const a = document.createElement("a");
        a.href = canvas.toDataURL("image/png");
        a.download = "minocesari-com-qr.png";
        a.click();
    };

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    data-testid="qr-modal"
                    className="fixed inset-0 z-[70] flex items-center justify-center bg-[#090a0c]/92 p-6 backdrop-blur-xl"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div
                        className="card-frame relative flex w-full max-w-sm flex-col items-center gap-7 rounded-2xl bg-[#121418] px-8 py-10"
                        initial={{ scale: 0.92, y: 28, opacity: 0 }}
                        animate={{ scale: 1, y: 0, opacity: 1 }}
                        exit={{ scale: 0.95, opacity: 0 }}
                        transition={{ duration: 0.55, ease: EASE }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            data-testid="qr-modal-close-button"
                            onClick={onClose}
                            className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full border border-[rgba(226,192,117,0.25)] text-[#a1a8b3] transition-colors hover:text-[#e2c075]"
                            aria-label="Chiudi"
                        >
                            <X className="h-4 w-4" />
                        </button>
                        <p className="font-code text-[10px] uppercase tracking-[0.35em] text-[#a1a8b3]">
                            Scansiona · Apri il biglietto
                        </p>
                        <div className="rounded-2xl bg-[#f4f1ea] p-5 shadow-[0_16px_50px_rgba(0,0,0,0.55)]">
                            <QRCodeCanvas
                                id="qr-canvas-full"
                                value={window.location.origin}
                                size={230}
                                level="H"
                                fgColor="#090a0c"
                                bgColor="#f4f1ea"
                                imageSettings={{ src: MC_MARK_URL, height: 46, width: 46, excavate: true }}
                            />
                        </div>
                        <p className="font-display text-2xl italic text-gold-gradient">Il biglietto digitale</p>
                        <button
                            data-testid="qr-download-button"
                            onClick={downloadPng}
                            className="flex items-center gap-2 rounded-full border border-[rgba(226,192,117,0.35)] px-6 py-3 text-[#e2c075] transition-colors duration-300 hover:bg-[rgba(226,192,117,0.08)]"
                        >
                            <Download className="h-4 w-4" />
                            <span className="font-code text-[11px] uppercase tracking-[0.2em]">Scarica PNG</span>
                        </button>
                        <a
                            data-testid="qr-print-download-button"
                            href="/assets/qr-minocesari-stampa.png"
                            download="qr-minocesari-stampa-300dpi.png"
                            className="flex items-center gap-2 rounded-full bg-[#e2c075] px-6 py-3 text-[#090a0c] transition-transform duration-300 active:scale-[0.97]"
                        >
                            <Printer className="h-4 w-4 shrink-0" />
                            <span className="font-code whitespace-nowrap text-[11px] font-medium uppercase tracking-[0.2em]">
                                QR per stampa · 300 DPI
                            </span>
                        </a>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
